/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Credits_Expires_AtInputs */

const en_admin_credits_expires_at = /** @type {(inputs: Admin_Credits_Expires_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expires At`)
};

/**
* | output |
* | --- |
* | "Expires At" |
*
* @param {Admin_Credits_Expires_AtInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_credits_expires_at = /** @type {((inputs?: Admin_Credits_Expires_AtInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Credits_Expires_AtInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_credits_expires_at(inputs)
});
export { admin_credits_expires_at as "admin.credits.expires_at" }